import { uxlHandlers } from './api';
import { modelHandlers } from './models';

export const handlers = [...uxlHandlers, ...modelHandlers];
